var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgModel(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 14,
    viewBox: "0 0 21 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.2968 1H2.70321C1.76255 1 1 1.76256 1 2.70321V4.72536C1 5.66602 1.76255 6.42857 2.70321 6.42857H18.2968C19.2374 6.42857 20 5.66602 20 4.72536V2.70321C20 1.76256 19.2374 1 18.2968 1Z",
    stroke: "#6856DB",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M18.2968 6.42847H2.70321C1.76255 6.42847 1 7.19102 1 8.13168V10.1538C1 11.0945 1.76255 11.857 2.70321 11.857H18.2968C19.2374 11.857 20 11.0945 20 10.1538V8.13168C20 7.19102 19.2374 6.42847 18.2968 6.42847Z",
    stroke: "#6856DB",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M3.71436 3.71436H4.39293",
    stroke: "#6856DB",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M7.78589 3.71436H17.2859",
    stroke: "#6856DB",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M3.71436 9.14282H4.39293",
    stroke: "#6856DB",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M7.78589 9.14282H17.2859",
    stroke: "#6856DB",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M17.9643 11.8572H15.25V13.2143H17.9643V11.8572Z",
    stroke: "#6856DB",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M5.74993 11.8572H3.03564V13.2143H5.74993V11.8572Z",
    stroke: "#6856DB",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgModel);
export default __webpack_public_path__ + "static/media/Model.630b4e417b5af6de12b6ec65b98a40b2.svg";
export { ForwardRef as ReactComponent };